import React from 'react';
import { Button } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import { makeStyles } from '@material-ui/styles';

export default function DurationButton({ title, onClick, selected }) {
  const theme = useTheme();

  const useStyles = makeStyles({
    root: {
      backgroundColor: selected ? '#009ef7' : theme.palette.mode === "light" ? "#f1faff" : "#212e48",
      paddingY: '11px',
      color: selected ? '#fff' : '#009ef7',
      fontSize: '14px',
      fontWeight: 500,
      textTransform: 'none',
      '&:hover ': {
        backgroundColor: "#009ef7",
        color: '#fff',
      }
    }
  });
  const classes = useStyles();

  return (
    <Button
      onClick={onClick}
      fullWidth
      variant="contained"
      color="primary"
      classes={{ root: classes.root }}
    >
      {title}
    </Button>
  );
}
